import { createSlice } from "@reduxjs/toolkit";

const utilSlice = createSlice({
  name: "utils",
  initialState: {
    notificationOpen: false,
    notificationMessage: "",
    loader: false,
  },
  reducers: {
    setNotification(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const utilActions = utilSlice.actions;

export default utilSlice;
